module.exports = __webpack_public_path__ + "img/vivobooks14.9383b3b7.jpg";